import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

/** A custom validator function that requires a specific field based on another field's value */
export function conditionalRequiredValidator(targetKey: string, conditionalKey: string, requiredValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const group = control as FormGroup; // Safely type cast to FormGroup
        const target = group.get(targetKey);
        const conditional = group.get(conditionalKey);

        if (conditional && target) {
            if (conditional.value === requiredValue && (target.value == null || target.value === '')) {
                // If the condition is met and the target field is empty, set an error.
                return { required: true };
            }
        }
        return null; // If no errors, return null.
    };
}
